import { render } from "./MessageGroupLeaveConfirmation.vue?vue&type=template&id=30cbaf7c&scoped=true&ts=true"
import script from "./MessageGroupLeaveConfirmation.vue?vue&type=script&lang=ts"
export * from "./MessageGroupLeaveConfirmation.vue?vue&type=script&lang=ts"

import "./MessageGroupLeaveConfirmation.vue?vue&type=style&index=0&id=30cbaf7c&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cbaf7c"]])

export default __exports__